import React from 'react';
import {Checkbox,Box, FormControl, FormLabel,useTheme,FormControlLabel} from '@mui/material';

import{Field,Form,ErrorMessage} from 'formik';
import {tokens,ColorModeContext} from '../../../../theme'

const CheckBox = (props) => {
  const theme=useTheme();
  const colors=tokens(theme.palette.mode)
  const{name,label,options,...rest}=props;

  return (
      <Field name={name} {...rest} >
    {
      ({field})=>{
        return (options.map(option=>{

         return(
                 
                  <Box key={option.value}   sx={{display:'flex',justifyContent:'start',alignItems:'center'}} >
                  <FormControl sx={{bgcolor:''}}>
                  <Checkbox
                   type='checkbox'
                   id={option.value}     
                   {...field}
                   value={option.value}
                   checked={field.value.includes(option.value)}

                   sx={{
                    color: colors.blueAccent[600],
                    '&.Mui-checked': {
                      color: colors.blueAccent[100],
                    },
                    padding:0,margin:'2px'
                  }}
                   
                  />
                 
                  </FormControl>
                  <FormLabel sx={{fontSize:'0.6rem',color:colors.grey[100]}} htmlFor={option.value} >{option.key}</FormLabel>

           

                 
                  </Box>
                

                
                 )
        }))

        
      }
    }
      </Field>

      
   
  )
}

export default CheckBox